var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pipeline)?_c('ExecutionHistory',{key:_vm.pipeline.id,attrs:{"workflowId":_vm.pipeline.id,"workflowType":_vm.WorkflowType.DataCheckin,"isLongRunning":_vm.isLongRunning,"routeName":_vm.routerName}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }